/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const __vue_script__ = {
    name: 'MediaInfo',

    props: {
        details: {
            type: Object,
            default: () => {}
        },
        isContentHub: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            isVideo: !this.details.type || this.details.type === 'mp4'
        };
    },

    computed: {
        /** @returns {string} */
        displayTimestamp() {
            return this.$utils.time.tsToFormat(this.details.timestamp);
        },

        /** @returns {string} */
        fileSizeLabel() {
            if (this.details.file_size) {
                return this.$utils.numbers.humanFileSize(this.details.file_size);
            } else if (this.details.upload_error) {
                return this.$i18n.t('contents.detail.failed').toString();
            } else {
                return this.$i18n.t('contents.detail.processing').toString();
            }
        },
    },
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-info"},[_c('div',{staticClass:"details"},[(_vm.isContentHub)?_c('div',{staticClass:"status"},[_c('span',[_vm._v(_vm._s(_vm.$t('contents.detail.status')))]),_c('div',{staticClass:"badge",class:_vm.details.published && 'success'},[_vm._v(_vm._s(_vm.details.published ? _vm.$t('contents.detail.published') : _vm.$t('contents.detail.unpublished')))])]):_vm._e(),(_vm.isVideo && (_vm.details.views || _vm.details.claps))?_c('div',{staticClass:"stats"},[_c('div',{staticClass:"stats-item"},[_vm._m(0),_c('span',[_vm._v(_vm._s(_vm.details.views))])]),_c('div',{staticClass:"stats-item"},[_c('div',{staticClass:"stats-icon",attrs:{"aria-hidden":"true","title":"claps"}},[_vm._v("👏")]),_c('span',[_vm._v(_vm._s(_vm.details.claps))])])]):_vm._e()]),_c('div',{staticClass:"info"},[_c('div',{staticClass:"media-info-labels"},[(_vm.isContentHub)?_c('div',{staticClass:"media-info-label"},[_vm._v(_vm._s(_vm.$t('contents.detail.source'))+":")]):_vm._e(),_c('div',{staticClass:"media-info-label"},[_vm._v(_vm._s(_vm.$t('contents.detail.file_size'))+":")]),(!_vm.isVideo)?_c('div',{staticClass:"media-info-label"},[_vm._v(_vm._s(_vm.$t('contents.detail.type'))+":")]):_vm._e(),_c('div',{staticClass:"media-info-label"},[_vm._v(_vm._s(_vm.$t('contents.detail.date'))+":")])]),_c('div',{staticClass:"media-info-values"},[(_vm.isContentHub)?_c('div',{staticClass:"media-info-value"},[_vm._v(" "+_vm._s(_vm.details.eventName || _vm.$t('contents.detail.uploaded')))]):_vm._e(),_c('div',{staticClass:"media-info-value"},[_vm._v(_vm._s(this.fileSizeLabel))]),(!_vm.isVideo)?_c('div',{staticClass:"media-info-value"},[_vm._v(_vm._s(_vm.details.type.toUpperCase()))]):_vm._e(),_c('div',{staticClass:"media-info-value"},[_vm._v(_vm._s(_vm.displayTimestamp))])])])])}
var __vue_staticRenderFns__ = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats-icon"},[_c('i',{staticClass:"ic-eye",attrs:{"aria-hidden":"true","title":"views"}})])}]

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MediaInfo.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__